var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: "introPage",
    staticClass: "page__intro-page"
  }, [_c('div', {
    staticClass: "back-to-home rounded d-none d-sm-block"
  }, [_c('a', {
    staticClass: "btn btn-icon btn-soft-primary",
    attrs: {
      "href": "index.html"
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "home"
    }
  })], 1)]), _c('section', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col px-0 px-md-2"
  }, [_vm.currentProject.intro_img ? _c('div', {
    staticClass: "page__data-enter__image-wrapper"
  }, [_c('img', {
    staticClass: "img-fluid d-block mx-auto mt-4",
    attrs: {
      "src": _vm.helperImgPath(_vm.currentProject.intro_img),
      "alt": _vm.currentProject.title
    }
  })]) : _c('div', {
    staticClass: "page__data-enter__image-wrapper"
  }, [_c('img', {
    staticClass: "img-fluid d-block mx-auto mt-4",
    attrs: {
      "src": require("@/assets/images/illustrator/Mobile_notification_SVG.svg")
    }
  })])])]), _c('div', {
    staticClass: "row my-4"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentProject.intro_text)
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "size": "lg"
    },
    on: {
      "click": function click($event) {
        return _vm.proceed();
      }
    }
  }, [_vm._v("Pričnite z vprašanji")])], 1)]), _vm.currentPackage && _vm.packageProjectOrder && _vm.packageProjectOrder < _vm.packageLength ? _c('ProgressBarContainer', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('p', [_vm._v(" Sklop "), _c('span', [_vm._v(_vm._s(_vm.packageProjectOrder + 1))]), _vm._v(" od " + _vm._s(_vm.packageLength) + " ")])];
      },
      proxy: true
    }, {
      key: "bar",
      fn: function fn() {
        return [_c('b-progress', {
          staticClass: "rounded",
          attrs: {
            "value": _vm.packageProjectOrder + 1,
            "max": _vm.packageLength,
            "height": "0.5rem",
            "variant": "primary"
          }
        })];
      },
      proxy: true
    }], null, false, 725743)
  }) : _vm._e()], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }